import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HowItWorks from '../components/HowItWorks';

const HowItWorksPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-6 text-center">How Profind.ca Works</h1>
        <p className="text-lg text-gray-600 mb-12 text-center">Finding the right professional for your project is simple</p>
      </div>
      <HowItWorks />
      <Footer />
    </div>
  );
};

export default HowItWorksPage;